<template>
    <v-card flat>
        <v-card-text>
            <v-container fluid>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-dialog v-model="obModal.open" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"  persistent max-width="35%">
                            <v-card elevation="11">
                                <v-card-title class="bg-title-card"> <span class="white--text headline" v-html="obModal.titulo"></span></v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-form ref="formModal">
                                            <v-row dense>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field label="N° Cuota *" color="textbox" v-model="obModal.nroCuota"
                                                        outlined disabled dense />
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field label="Valor *" color="textbox" v-model="obModal.valor"
                                                        outlined :rules="_.concat(requeridoRegla,decimal)" dense />
                                                </v-col>
                                                <v-col cols="12" sm="12">
                                                    <v-dialog ref="dialog" v-model="obDate.open" :return-value.sync="obModal.fechaVencimiento"
                                                        persistent width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field color="textbox" v-model="obModal.fechaVencimiento"
                                                                label="Fecha de Vencimiento *" :rules="requeridoRegla" prepend-inner-icon="event"
                                                                outlined dense v-on="on" />
                                                        </template>
                                                        <v-date-picker color="primary" v-model="obModal.fechaVencimiento" scrollable locale="es">
                                                            <v-spacer></v-spacer>
                                                            <v-btn outlined dense rounded @click="obDate.open = false" v-text="'Salir'">
                                                            </v-btn>
                                                            <v-btn rounded dark color="primary" @click="$refs.dialog.save(obModal.fechaVencimiento)"
                                                                v-text="'Guardar Fecha'"></v-btn>
                                                        </v-date-picker>
                                                    </v-dialog>
                                                </v-col>
                                            </v-row>
                                        </v-form>

                                        <v-row dense>
                                            <v-col class="mt-3 mb-3 text-right">
                                                <v-btn outlined class="mr-1" rounded @click="cerrarModal">Cancelar</v-btn>
                                                <v-btn color="primary" rounded  @click="validarModal">Guardar</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>

                <v-form ref="form">
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-autocomplete dense label="Forma de Pago *" color="textbox" v-model="obForm.idFormaPago"
                                :items="listTipoFormaPago" @change="onAmortizacion"
                                item-value="idFormaPago" item-text="formaPago" outlined 
                                :rules="requeridoRegla" />
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field label="N° Cuotas *" color="textbox" v-model="obForm.nroCuota"
                                outlined :rules="visible ? _.concat(requeridoRegla,decimal) : []" dense />
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field label="Cuota Inicio *" color="textbox" v-model="obForm.cuotaInicio"
                                outlined :rules="visible ? _.concat(requeridoRegla,decimal) : []" dense />
                        </v-col>
                    </v-row>

                    <v-row dense v-if="visible">
                        <v-col cols="12" sm="6"></v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Buscar" color="textbox" v-model="obForm.search" clearable
                                prepend-inner-icon="search" />
                        </v-col>
                    </v-row>

                    <v-row dense v-if="visible">
                        <v-col cols="12" sm="12">
                            <v-data-table :search="obForm.search" :headers="cabecera"
                                :items="detalle" class="elevation-3">  

                                <template v-slot:body.append>
                                    <tr>
                                            <td>
                                                <span class="font-weight-black"
                                                        v-html="'Total'"></span>
                                            </td>
                                            <td>
                                                <span class="font-weight-black"
                                                        v-html="`$${Number.parseFloat(primaTotal).toFixed(2) }`"></span>
                                            </td>
                                            <td></td>
                                            <td></td>
                                    </tr>
                                </template>

                                <template v-slot:item.name="{ item }">
                                    <v-btn class="ma-2" text icon color="primary" @click="editItem(item)" v-if="item.edit">
                                        <v-icon small>edit</v-icon>
                                    </v-btn>
                                </template>

                                <template v-slot:no-results>
                                    Tu búsqueda de "<span v-text="obForm.search"></span>" no arrojó resultados.
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="12" class="text-right mt-3 mb-3">
                            <v-btn rounded outlined class="mr-1" 
                                   @click="setData('obForm.amortizacion',detalle);setData('obForm.obFormaPago',obForm);setData('step',3)">Anterior</v-btn>
                            <v-btn rounded color="primary" @click="validar" :disabled="disabled">Guardar</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'StepperDatosFormaPagoComponent',
        inject:['setData','insertar'],
        props:{
            load:{
                type:Boolean,
                default:false
            },
            listTipoFormaPago:{
                type:Array,
                default: () => []
            },
            primaTotal:{
                type:Number,
                default:0
            },
            parametros:{
                type:Object,
                default:{}
            },
            obDatosPrincipal:{
                type:Object,
                default:{}
            }
        },
        data: () => ({
            cabecera:[
                { text: 'N° Cuota', value: 'secCuota', class: 'caption text-xs-center active' },
                { text: 'Valor', value: 'valor',class: 'caption text-xs-center' },
                { text: 'Fecha Vencimiento', value: 'fechaVencimiento',class: 'caption text-xs-center'},
                { text: 'Editar', value: 'name',class: 'caption text-xs-center'}
            ],
            detalle:[],
            obForm:{
                search:'',
                idFormaPago:null,
                nroCuota:null,
                cuotaInicio:null
            },
            obModal:{
                open:false,
                titulo:'Editar Cuota',
                nroCuota:null,
                fechaVencimiento:null,
                valor:null
            },
            obDate:{
                open:false
            },
            disabled:false
        }),
        watch:{
            load(val){
                if(val){
                    this.disabled = !_.isUndefined(this.obDatosPrincipal.idCertificado) && !_.isNull(this.obDatosPrincipal.idCertificado) ? true : false;
                    this.obForm.idFormaPago = !_.isUndefined(this.obForm.idFormaPago) && !_.isNull(this.obForm.idFormaPago) ? this.obForm.idFormaPago : this.listTipoFormaPago[0].idFormaPago;
                    
                    if(this.disabled){
                        this.obForm = _.merge({},this.obForm,_.pick(this.obDatosPrincipal,['idCertificado','idPoliza','idFormaPago','cuotaInicio','nroCuota']));
                        this.obForm.cuotaInicio = Number.parseFloat(this.obForm.cuotaInicio).toFixed(2);

                        var error = 'E';
                        this.detalle = [];
                        axios.post(`${BASE_URI}administrador/forma-pago/listar`,_.merge({opcion:'LISTAR'},_.pick(this.obForm,['idCertificado','idPoliza'])))
                             .then((r)=>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                    
                                    this.detalle = _.map(r.data.data,(v,k)=>{
                                                        v.index = _.uniqueId();
                                                        v.edit = true;
                                                        v.mod = k == 0 ? false : true;
                                                        v.nroCuota = _.toNumber(v.nroCuota);
                                                        v.valor = Number.parseFloat(v.valor).toFixed(2);
                                                        return v;
                                                    });

                                    this.disabled = false;
                             })
                             .catch((e)=>{
                                mensajesAlerta(e,error);
                            });
                    }
                }
            },
            obForm:{
                handler(val,oldVal){
                    if(
                        (_.toNumber(val.idFormaPago) == this.parametros.idFormaPagoCredito) &&
                        (_.toNumber(val.cuotaInicio) > 0) && (_.toNumber(val.nroCuota) > 0) &&
                        !this.disabled
                    ){
                        this.onAmortizacion();
                    }
                },
                deep:true
            }
        },
        computed:{
            visible(){
                var t = _.toNumber(this.obForm.idFormaPago) == this.parametros.idFormaPagoCredito ? true : false;
                return t && (_.toNumber(this.obForm.cuotaInicio) > 0) && (_.toNumber(this.obForm.nroCuota) > 0) ? true : false;
            }
        },
        methods:{
            onAmortizacion(){
                var l = _.range(1,_.toNumber(this.obForm.nroCuota)+1);
                var date = moment().format('YYYY-MM-DD');
                var lista = this.detalle;
                this.detalle = [];


                this.detalle.push({
                    nroCuota:0,
                    secCuota:0,
                    idSecFormaPagoCab: _.get(lista,['0','idSecFormaPagoCab'],null),
                    idSecFormaPagoDet: _.get(lista,['0','idSecFormaPagoDet'],null),
                    valor:_.toNumber(this.obForm.cuotaInicio),
                    fechaVencimiento: '',
                    edit:false,
                    index:_.uniqueId()
                });

                _.forEach(l,(v,k)=>{
                    var valor = (this.primaTotal - _.toNumber(this.obForm.cuotaInicio))/_.toNumber(this.obForm.nroCuota);
                    date = moment(date,'YYYY-MM-DD').add(1, 'months').format('YYYY-MM-DD');

                    this.detalle.push({
                        nroCuota:v,
                        secCuota:k+1,
                        idSecFormaPagoCab: _.get(lista,[k+1,'idSecFormaPagoCab'],null),
                        idSecFormaPagoDet: _.get(lista,[k+1,'idSecFormaPagoDet'],null),
                        valor:_.round(valor,2),
                        fechaVencimiento: date,
                        edit:true,
                        index:_.uniqueId(),
                        mod:false
                    });
                });

                this.setData('obForm.amortizacion',this.detalle);
            },
            editItem(v){
                this.obModal = _.merge({},this.obModal,v,{open:true});
            },
            validar(){
                try {
                    if(!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                    if(this.disabled) throw 'Proceso se esta ejectutando.';
                        this.setData('obForm.obFormaPago',_.pick(this.obForm,['idFormaPago','nroCuota','cuotaInicio']));
                        this.setData('obForm.amortizacion',this.detalle);
                        this.disabled = true;

                        this.insertar()
                            .then((r)=>{
                                if(!r) throw 'error';
                            })
                            .catch((e)=>{
                                this.disabled = false;
                            });
                } catch (error) {
                    mensajesAlerta(error,'I');
                    this.disabled = false;
                }
            },
            validarModal(){
                try {
                    if(!this.$refs.formModal.validate()) throw mensajeEstandar.corregirInformacion;
                        this.obModal.mod = true;
                        this.obModal.valor = _.toNumber(this.obModal.valor);
                        var l = _.cloneDeep(this.detalle);
                        var index = _.findIndex(l,{'index':this.obModal.index});
                        l[index] = _.merge(l[index],_.omit(this.obModal,['titulo','open']));

                        var lFilter = _.filter(l,(o)=>{ return o.mod && o.edit });
                        var sumValMod = _.round(_.sumBy(lFilter,'valor'),2);
                        var newValor = (this.primaTotal - (sumValMod + _.toNumber(this.obForm.cuotaInicio)))/(_.toNumber(this.obForm.nroCuota) - _.size(lFilter));

                        l = _.map(l,(v)=>{
                                if(!v.mod && v.edit && v.index != this.obModal.index)
                                    v.valor = _.round(newValor,2);

                                return v;
                            });

                        this.setData('obForm.amortizacion',l);
                        this.detalle = l;
                        this.cerrarModal();
                } catch (error) {
                    mensajesAlerta(error,'I');
                }
            },
            cerrarModal(){
                this.obModal ={
                    open:false,
                    titulo:'Editar Cuota',
                    nroCuota:null,
                    fechaVencimiento:null,
                    valor:null
                }
            }
        }
    }
</script>